import { Navigate, useLocation } from 'react-router-dom';

function OrganizationDetailIndexRedirect() {
    const location = useLocation();

    return <Navigate to={`services${location.search}`} replace />;
}

export default OrganizationDetailIndexRedirect;
